import logger from '@/modules/Logger';

export default {
  install(Vue) {
    Vue.prototype.$logger = logger
  }
};
